import FileResultModal from './FileResultModal';
import React from 'react';

class FileDeleteResultModal extends React.Component<{
  open?: boolean;
  headerText: string;
  text: string;
  deletedUsers?: number;
  notFoundUsers?: number;
  usersNotFoundList?: string[];
  downloadMessageText?: string;
  showSuccessMessageOnly: boolean;
  buttonText: string;
  buttonSize?: 'small' | 'medium' | 'large';
  handleButtonClick: () => void;
}> {
  render() {
    const {
      open,
      headerText,
      text,
      deletedUsers,
      notFoundUsers,
      usersNotFoundList,
      downloadMessageText,
      showSuccessMessageOnly,
      buttonText,
      buttonSize,
      handleButtonClick,
    } = this.props;
    const details = [
      { text: `Users were deleted: ${deletedUsers?.toString()}` },
      { text: `Users were not found: ${notFoundUsers?.toString()}` },
      { text: '', usersNotFoundList },
    ];

    return (
      <FileResultModal
        open={open}
        headerText={headerText}
        text={text}
        details={details}
        downloadMessageText={downloadMessageText}
        showSuccessMessageOnly={showSuccessMessageOnly}
        buttonText={buttonText}
        buttonSize={buttonSize}
        handleButtonClick={handleButtonClick}
      />
    );
  }
}

export default FileDeleteResultModal;
